import { render, staticRenderFns } from "./UserCharacters.vue?vue&type=template&id=f29d3448&scoped=true"
import script from "./UserCharacters.vue?vue&type=script&lang=js"
export * from "./UserCharacters.vue?vue&type=script&lang=js"
import style0 from "./UserCharacters.vue?vue&type=style&index=0&id=f29d3448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29d3448",
  null
  
)

export default component.exports